import MixedMedia from '../mixed-media';
import * as s from './styles';
import type { IMixedMedias } from './types';

const MixedMedias = ({ mixedMediaData, currentIndex, ...props }: IMixedMedias) => (
  <s.StyledMixedMedias {...props}>
    {mixedMediaData.map((media, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <s.MediaWrapper key={index} $show={currentIndex === index} aria-hidden={currentIndex !== index}>
        <MixedMedia mixedMedia={media} />
      </s.MediaWrapper>
    ))}
  </s.StyledMixedMedias>
);

export default MixedMedias;
